import { Check, Cloud, Code2, DatabaseZap, Gauge, Layers3 } from "lucide-react";
import { siteStack } from "../data/siteStack";
import { SectionHeading } from "./SectionHeading";

const icons = [Layers3, Code2, DatabaseZap, Gauge, Cloud, Check];

export function StackManifest() {
  return (
    <section className="section shell stack-section" aria-labelledby="stack-title">
      <SectionHeading
        number="07"
        eyebrow="Under the hood / actual manifest"
        title="The site is part of the work."
        description="Pulled from this repository’s configuration—not from memory."
      />
      <div className="stack-manifest">
        <div className="manifest-topbar">
          <div className="manifest-dots"><span /><span /><span /></div>
          <p id="stack-title">portfolio.build / system snapshot</p>
          <span>production-ready</span>
        </div>
        <div className="manifest-command"><span>›</span> describe --shape --runtime --delivery</div>
        <div className="manifest-output">
          <p className="manifest-status"><span>●</span> Exact stack, pulled from package.json and Wrangler configuration.</p>
          <dl>
            {siteStack.map((item, index) => {
              const Icon = icons[index];
              return (
                <div key={item.title}>
                  <dt><Icon aria-hidden="true" />{item.title}</dt>
                  <dd>{item.value}</dd>
                </div>
              );
            })}
          </dl>
          <div className="manifest-footer">
            <span><Check aria-hidden="true" /> Type-safe content</span>
            <span><Check aria-hidden="true" /> No database</span>
            <span><Check aria-hidden="true" /> Edge deployed</span>
            <span><Check aria-hidden="true" /> Accessible by design</span>
          </div>
        </div>
      </div>
    </section>
  );
}
